import { useCallback, useState } from "react";

import { GET_ONBOARDING_EMPLOYEE_LIST } from "../../../../../config/Endpoints.js";
import { getAuthToken } from "../../../../../utils/Storage.js";
import { ApiError, putApi } from "../../../../utils/api.ts";
import {
  hrApproveQueryParamsToSearch,
  type HrApproveQueryParams,
} from "../schemas/hr-approve.schema.ts";
import { useSqeLabs } from "../../../../hooks/use-sqe-labs.ts";
import { SQE_ONBOARDING } from "../../onboarding/sqe/sqe-onboarding-api.ts";

function accessToken(): string | undefined {
  const t = getAuthToken("accessToken");
  return t != null && t !== "" ? t : undefined;
}

export function useHrSetupApprove() {
  const isSqe = useSqeLabs();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const approveEmployee = useCallback(
    async (employeeId: string | number, params: HrApproveQueryParams) => {
      setLoading(true);
      setError(null);
      const id = encodeURIComponent(String(employeeId));
      const sqeParams = new URLSearchParams(hrApproveQueryParamsToSearch(params));
      sqeParams.delete("companyName");
      sqeParams.delete("employeeType");
      const url = isSqe
        ? `${SQE_ONBOARDING}/${id}/approve?${sqeParams.toString()}`
        : `${GET_ONBOARDING_EMPLOYEE_LIST}/v2/${id}/approve?${hrApproveQueryParamsToSearch(params)}`;
      try {
        const { data } = await putApi<{ message?: string }>(url, accessToken(), {});
        return data;
      } catch (e) {
        const msg = e instanceof ApiError ? e.message : "Failed to approve employee.";
        setError(msg);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [isSqe],
  );

  return { approveEmployee, loading, error };
}
